module.exports = __webpack_public_path__ + "img/slider4.2d0967b4.svg";